module.exports = __webpack_public_path__ + "img/icon-home.1328169a.svg";